(function () {

  let allSlides = [];
  let flkty = null;

  document.addEventListener('DOMContentLoaded', function () {

    setTimeout(function () {

      const variantSelect = document.querySelector('select[name="id"]');

      if (!variantSelect) return;

      const selectedOption =
        variantSelect.options[variantSelect.selectedIndex];

      if (!selectedOption) return;

      const parts = selectedOption.text.split('/');

      const color = parts[0].trim();

      // Extract only the number from the size
      const size = parts[1].match(/\d+/)?.[0] || '';

      console.log('Initial variant:', color, size);

      filterGallery(color);

      selectFrontImage(color, size);

      // Get Flickity instance
      flkty = Flickity.data(
        document.querySelector('.product-slideshow')
      );

      if (flkty) {

        allSlides = flkty.cells.map(function (cell) {
          return cell.element;
        });

        createGalleryArrows();

      }

    }, 500);

  });


  function normalizeColor(color) {

    if (!color) return '';

    color = color.toLowerCase();

    if (color.includes('denim')) return 'denim';

    if (color.includes('navy')) return 'navyblue';

    if (color.includes('khaki')) return 'khakitan';

    if (color.includes('ivory')) return 'ivory';

    if (color.includes('pink')) return 'pinkblush';

    if (color.includes('graphite')) return 'graphitegrey';

    if (color.includes('grey')) return 'graphitegrey';

    if (color.includes('gray')) return 'graphitegrey';

    return color
      .replace(/\s+/g, '')
      .replace(/-/g, '');

  }


   function filterGallery(color) {

        color = normalizeColor(color);

        // -----------------------
        // Main gallery slides
        // -----------------------
        document.querySelectorAll('.product-main-slide').forEach(function(slide){

            const set = normalizeColor(slide.dataset.setName);

            const img = slide.querySelector('img');
            const alt = img ? img.alt.toLowerCase() : '';

            // Show reusable images for every variant
            if (alt.includes('-all')) {
                slide.style.display = '';
                return;
            }

            // Hide images without a variant group
            if (!set) {
                slide.style.display = 'none';
                return;
            }

            // Show only selected color
            slide.style.display = (set === color) ? '' : 'none';

        });

        const flkty = Flickity.data(
            document.querySelector('.product-slideshow')
        );

        if (!flkty) return;

        // Rebuild Flickity
        flkty.reloadCells();
        flkty.resize();

        setTimeout(function() {

            const frontSlide = document.querySelector(
                '.product-main-slide[data-set-name="' +
                color +
                '"][data-group="' +
                color +
                '_1"]'
            );

            if (!frontSlide) {
                console.log('Front slide not found:', color);
                return;
            }

            const cellIndex = flkty.cells.findIndex(function(cell) {
                return cell.element === frontSlide;
            });

            console.log('Selected color:', color);
            console.log('Front slide:', frontSlide);
            console.log('Flickity cell index:', cellIndex);

            if (cellIndex === -1) {
                console.log('Front slide is not in Flickity cells');
                return;
            }

            // Select by Flickity index
            flkty.select(cellIndex, false, true);

        }, 150);
    }


  function selectFrontImage(color, size) {

    // Update thumbnails for selected size
    setTimeout(function () {

      updateSizeImage(color, size);

    }, 50);

  }


  function updateSizeImage(color, size) {

    const group = normalizeColor(color);

    if (!size) return;

    size = String(size).trim();


    document.querySelectorAll('.product__thumb-item').forEach(function (item) {

      const set = normalizeColor(item.dataset.setName);

      const imageGroup = item.dataset.group;

      const img = item.querySelector('img');

      const alt = img ? img.alt.toLowerCase() : '';


      // --------------------------------
      // Reusable images for ALL variants
      // --------------------------------

      if (alt.includes('-all')) {

        item.style.display = '';

        return;

      }


      // --------------------------------
      // Hide other colors
      // --------------------------------

      if (set !== group) {

        item.style.display = 'none';

        return;

      }


      // --------------------------------
      // Images without group
      // --------------------------------

      if (!imageGroup) {

        item.style.display = 'none';

        return;

      }


      // --------------------------------
      // Front image
      // --------------------------------

      if (imageGroup === group + '_1') {

        item.style.display = '';

        return;

      }


      // --------------------------------
      // Selected size image
      // --------------------------------

      if (imageGroup === group + '_' + size) {

        item.style.display = '';

        return;

      }


      // --------------------------------
      // Hide everything else
      // --------------------------------

      item.style.display = 'none';

    });


    console.log(
      'updateSizeImage():',
      color,
      size
    );

    console.log(
      'Expected group:',
      group + '_' + size
    );

  }


  // --------------------------------
  // Variant change
  // --------------------------------

  document.addEventListener(
    'variant:change',
    function (event) {

      if (!event.detail.variant) return;

      const variant = event.detail.variant;

      const color = variant.option1;

      const size =
        String(variant.option2)
          .match(/\d+/)?.[0] || '';


      console.log(
        'Variant changed:',
        color,
        size
      );


      // Filter main gallery
      filterGallery(color);


      // Update thumbnails
      setTimeout(function () {

        selectFrontImage(
          color,
          size
        );

      }, 100);

    }
  );
    // --------------------------------------------------
    // Keep popup gallery on the selected variant image
    // --------------------------------------------------
    document.addEventListener('click', function (event) {

        const zoomButton = event.target.closest('.product__photo-zoom');

        if (!zoomButton) return;

        const mainSlide = zoomButton.closest('.product-main-slide');

        if (!mainSlide) return;

        const flkty = Flickity.data(
            document.querySelector('.product-slideshow')
        );

        if (!flkty) return;

        const cellIndex = flkty.cells.findIndex(function(cell) {
            return cell.element === mainSlide;
        });

        if (cellIndex === -1) return;

        console.log(
            'Popup opening from:',
            mainSlide.dataset.setName,
            mainSlide.dataset.group,
            'Flickity index:',
            cellIndex
        );

        // Make sure Flickity knows this is the selected image
        flkty.select(cellIndex, false, true);

    });

/*arrows code */
    // --------------------------------------------------
  // CUSTOM LEFT / RIGHT ARROWS
  // --------------------------------------------------

 function createGalleryArrows() {

  const gallery =
    document.querySelector('.product-slideshow');

  if (!gallery) return;

  const flkty =
    Flickity.data(gallery);

  if (!flkty) return;

  // Prevent duplicate arrows
  if (
    gallery.querySelector('.custom-gallery-arrow')
  ) {
    return;
  }

  gallery.style.position = 'relative';


  // --------------------------------------------------
  // Previous button
  // --------------------------------------------------

  const prevButton =
    document.createElement('button');

  prevButton.type = 'button';

  prevButton.className =
    'custom-gallery-arrow custom-gallery-arrow--prev';

  prevButton.setAttribute(
    'aria-label',
    'Previous product image'
  );

  prevButton.innerHTML =
    '<span aria-hidden="true">‹</span>';


  // --------------------------------------------------
  // Next button
  // --------------------------------------------------

  const nextButton =
    document.createElement('button');

  nextButton.type = 'button';

  nextButton.className =
    'custom-gallery-arrow custom-gallery-arrow--next';

  nextButton.setAttribute(
    'aria-label',
    'Next product image'
  );

  nextButton.innerHTML =
    '<span aria-hidden="true">›</span>';


  gallery.appendChild(prevButton);
  gallery.appendChild(nextButton);


  // ==================================================
  // GET CURRENT VARIANT
  // ==================================================

  function getCurrentVariant() {

    const variantSelect =
      document.querySelector(
        'select[name="id"]'
      );

    if (!variantSelect) {
      return {
        color: '',
        size: ''
      };
    }

    const selectedOption =
      variantSelect.options[
        variantSelect.selectedIndex
      ];

    if (!selectedOption) {
      return {
        color: '',
        size: ''
      };
    }

    const parts =
      selectedOption.text.split('/');

    const color =
      normalizeColor(
        parts[0]?.trim() || ''
      );

    const size =
      parts[1]
        ?.match(/\d+/)?.[0] || '';

    return {
      color: color,
      size: size
    };

  }


  // ==================================================
  // CHECK IF IMAGE BELONGS TO CURRENT VARIANT
  // ==================================================

  function isAllowedSlide(slide) {

    if (!slide) return false;


    // -----------------------------------------------
    // Hidden by your existing gallery logic
    // -----------------------------------------------

    if (
      window.getComputedStyle(slide).display ===
      'none'
    ) {
      return false;
    }


    const img =
      slide.querySelector('img');

    const alt =
      img
        ? (img.alt || '').toLowerCase()
        : '';


    const set =
      normalizeColor(
        slide.dataset.setName || ''
      );

    const group =
      slide.dataset.group || '';


    const variant =
      getCurrentVariant();


    const color =
      variant.color;

    const size =
      variant.size;


    // =================================================
    // 1. SIZE-SPECIFIC REUSABLE IMAGES
    //
    // Example:
    //
    // 18midwest#all_18
    // 24midwest#all_24
    // 30midwest#all_30
    //
    // Only show the image for the selected size.
    // =================================================

    const allSizeMatch =
      alt.match(
        /#all_(\d+)/
      );


    if (allSizeMatch) {

      const imageSize =
        allSizeMatch[1];

      return imageSize === size;

    }


    // =================================================
    // 2. OTHER "-all" REUSABLE IMAGES
    //
    // These are allowed for all variants.
    // =================================================

    if (alt.includes('-all')) {

      return true;

    }


    // =================================================
    // 3. IMAGE WITHOUT GROUP
    // =================================================

    if (!set || !group) {

      return false;

    }


    // =================================================
    // 4. WRONG COLOR
    // =================================================

    if (set !== color) {

      return false;

    }


    // =================================================
    // 5. FRONT IMAGE
    //
    // Example:
    //
    // ivory_1
    // =================================================

    if (
      group ===
      color + '_1'
    ) {

      return true;

    }


    // =================================================
    // 6. SELECTED SIZE IMAGE
    //
    // Example:
    //
    // ivory_30
    // =================================================

    if (
      group ===
      color + '_' + size
    ) {

      return true;

    }


    // =================================================
    // Everything else is excluded
    // =================================================

    return false;

  }


  // ==================================================
  // GET ONLY VALID SLIDES
  // ==================================================

  function getAllowedSlides() {

    return flkty.cells
      .map(function(cell) {

        return cell.element;

      })
      .filter(function(slide) {

        return isAllowedSlide(slide);

      });

  }


  // ==================================================
  // MOVE TO IMAGE
  // ==================================================

  function moveToSlide(direction) {

    const slides =
      getAllowedSlides();

    if (!slides.length) return;


    const currentSlide =
      flkty.selectedElement;


    let currentIndex =
      slides.indexOf(currentSlide);


    // -----------------------------------------------
    // If current Flickity slide isn't valid,
    // select the first valid image.
    // -----------------------------------------------

    if (currentIndex === -1) {

      const firstSlide =
        slides[0];

      const firstIndex =
        flkty.cells.findIndex(
          function(cell) {

            return (
              cell.element ===
              firstSlide
            );

          }
        );


      if (firstIndex !== -1) {

        flkty.select(
          firstIndex,
          false,
          true
        );

      }

      return;

    }


    let newIndex =
      currentIndex + direction;


    // -----------------------------------------------
    // Loop around
    // -----------------------------------------------

    if (
      newIndex < 0
    ) {

      newIndex =
        slides.length - 1;

    }


    if (
      newIndex >= slides.length
    ) {

      newIndex = 0;

    }


    const targetSlide =
      slides[newIndex];


    const targetIndex =
      flkty.cells.findIndex(
        function(cell) {

          return (
            cell.element ===
            targetSlide
          );

        }
      );


    if (targetIndex === -1) return;


    flkty.select(
      targetIndex,
      true,
      false
    );

  }


  // ==================================================
  // PREVIOUS
  // ==================================================

  prevButton.addEventListener(
    'click',
    function(event) {

      event.preventDefault();
      event.stopPropagation();

      moveToSlide(-1);

    }
  );


  // ==================================================
  // NEXT
  // ==================================================

  nextButton.addEventListener(
    'click',
    function(event) {

      event.preventDefault();
      event.stopPropagation();

      moveToSlide(1);

    }
  );


  console.log(
    'Custom product gallery arrows initialized'
  );

}

/* end new arrows */




})();